import { useEffect, useState } from 'react';
import InfoDialogUI from '../../components/InfoDialog/InfoDialogUI';
import Loader from '../../components/Loader/Loader';
import { useUserContext } from '../../contexts/UserContext';
import { GLOBAL_FALLBACK_SLUG, buildMeetingEmbedUrl, resolveRepMeetingSlug } from './hubspotMeetingApi';
import styles from './TalkToSalesBookingModal.module.scss';

// Talk-to-Sales booking widget: resolves who the visitor last met with in
// HubSpot and embeds that rep's real meetings page (falls back to the shared
// team link otherwise).
export const TalkToSalesBookingModal = ({ open = false, onClose = null }) => {
  const { currentUser } = useUserContext();
  const user = currentUser?.user;

  const [resolvingRep, setResolvingRep] = useState(true);
  const [embedUrl, setEmbedUrl] = useState(null);

  useEffect(() => {
    if (!open) return;

    setResolvingRep(true);
    setEmbedUrl(null);

    let cancelled = false;
    (async () => {
      const matchedSlug = user?.email ? await resolveRepMeetingSlug(user.email) : null;
      if (cancelled) return;

      const url = buildMeetingEmbedUrl({
        slug: matchedSlug || GLOBAL_FALLBACK_SLUG,
        firstName: user?.first_name,
        lastName: user?.last_name,
        email: user?.email,
      });
      setEmbedUrl(url);
      setResolvingRep(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [open, user?.email, user?.first_name, user?.last_name]);

  if (!open) return null;

  return (
    <InfoDialogUI
      title="Book Your Upgrade Consultation"
      description="Choose a convenient time to meet with our product expert."
      titleStyle={{ marginBottom: '0.25rem' }}
      descriptionStyle={{ marginTop: '0.25rem', marginBottom: '0.75rem' }}
      show
      onClose={onClose}
      size="lg">
      <div className={styles.wrapper}>
        <Loader position="absolute" loading={resolvingRep} backdrop />
        {!resolvingRep && embedUrl ? (
          <iframe
            className={styles.meetingFrame}
            src={embedUrl}
            title="Book a meeting"
            frameBorder="0"
          />
        ) : null}
      </div>
    </InfoDialogUI>
  );
};

export default TalkToSalesBookingModal;
